export default {
  setToken(token) {
    localStorage.setItem("access_token", token);
  },
  getToken() {
    return localStorage.getItem("access_token");
  },
  deleteToken() {
    localStorage.removeItem("access_token");
  },
  deleteUser() {
    localStorage.removeItem("user");
  },
  setUser(user) {
    localStorage.setItem("user", JSON.stringify(user));
  },
  getUser() {
    try {
      const user = localStorage.getItem("user");
      if (user !== null) {
        return JSON.parse(user);
      }
      return null;
    } catch (e) {
      this.logOut();
      return null;
    }
  },
  deleteChat() {
    localStorage.removeItem("viewpath");
    localStorage.removeItem("conversations");
    localStorage.removeItem("chat");
  },
  logOut() {
    this.deleteToken();
    this.deleteUser();
    this.deleteChat();
    // return ApiService.get('/login');
  },
};
